export default function isInternetExplorer(): boolean {
  return window.document.documentMode ? true : false;
}
